import * as React from 'react';
import xss from 'xss';

interface RenderHTMLProps {
    html: string;
    className?: string;
    style?: React.CSSProperties;
}

export const RenderHTML = React.forwardRef((props: RenderHTMLProps, ref: React.Ref<HTMLDivElement>) => {
    const allowedAttributes = ['class', 'style', 'height', 'border', 'cellpadding', 'cellspacing'];

    const options = {
        onTagAttr: function (tag: string, name: string, value: string) {
            if (allowedAttributes.includes(name)) {
                return `${name}="${value}"`;
            }
        }
    };
    return <div ref={ref} style={props.style} className={props.className} dangerouslySetInnerHTML={{ __html: xss(props.html, options) }} />;
});
